module.exports = __webpack_public_path__ + "static/media/matteo-pulcrano.9a51b629.jpg";